import React from "react";

import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { cn } from "../../lib/utils";

// 0 = domingo, para bater com Date.getDay() no servidor.
const DIAS = [
  { dia: 1, nome: "Segunda" },
  { dia: 2, nome: "Terça" },
  { dia: 3, nome: "Quarta" },
  { dia: 4, nome: "Quinta" },
  { dia: 5, nome: "Sexta" },
  { dia: 6, nome: "Sábado" },
  { dia: 0, nome: "Domingo" },
];

const PADRAO = { aberto: true, abre: "09:00", fecha: "18:00" };

// Horário de funcionamento, um dia por linha. Sem nada configurado, atende
// sempre — é o que espera quem nunca abriu esta tela.
const BusinessHoursEditor = ({ valor, onChange }) => {
  const horarios = Array.isArray(valor) ? valor : [];

  const doDia = (dia) =>
    horarios.find((h) => Number(h.dia) === dia) || { dia, ...PADRAO };

  const alterar = (dia, mudanca) => {
    const atual = doDia(dia);
    const novo = { ...atual, ...mudanca, dia };

    onChange([...horarios.filter((h) => Number(h.dia) !== dia), novo]);
  };

  const usarEmTodos = () => {
    const segunda = doDia(1);

    onChange(
      DIAS.map(({ dia }) => ({
        dia,
        // Fim de semana costuma ser exceção; copiar "aberto" para sábado e
        // domingo criaria mais trabalho do que poupa.
        aberto: dia === 0 || dia === 6 ? doDia(dia).aberto : segunda.aberto,
        abre: segunda.abre,
        fecha: segunda.fecha,
      })),
    );
  };

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">Horário de atendimento</p>
        <button
          type="button"
          onClick={usarEmTodos}
          className="text-xs font-medium text-primary hover:underline"
        >
          Repetir a segunda nos dias úteis
        </button>
      </div>

      <div className="divide-y rounded-lg border">
        {DIAS.map(({ dia, nome }) => {
          const h = doDia(dia);

          return (
            <div key={dia} className="flex items-center gap-2 px-3 py-2">
              <Switch
                id={`dia-${dia}`}
                checked={!!h.aberto}
                onCheckedChange={(v) => alterar(dia, { aberto: v })}
              />

              <label
                htmlFor={`dia-${dia}`}
                className={cn(
                  "w-20 shrink-0 text-xs",
                  h.aberto ? "font-medium" : "text-muted-foreground",
                )}
              >
                {nome}
              </label>

              {h.aberto ? (
                <div className="flex items-center gap-1.5">
                  <Input
                    type="time"
                    aria-label={`${nome}: abre às`}
                    value={h.abre || ""}
                    onChange={(e) => alterar(dia, { abre: e.target.value })}
                    className="h-8 w-[110px] text-xs"
                  />
                  <span className="text-xs text-muted-foreground">até</span>
                  <Input
                    type="time"
                    aria-label={`${nome}: fecha às`}
                    value={h.fecha || ""}
                    onChange={(e) => alterar(dia, { fecha: e.target.value })}
                    className="h-8 w-[110px] text-xs"
                  />
                </div>
              ) : (
                <span className="text-xs text-muted-foreground">Fechado</span>
              )}
            </div>
          );
        })}
      </div>

      <p className="text-xs text-muted-foreground">
        Sem nenhum dia marcado, a conexão atende a qualquer hora.
      </p>
    </div>
  );
};

export default BusinessHoursEditor;
